import axios, { AxiosRequestConfig } from 'axios';

const URL_ROOT = `${process.env.REACT_APP_BASE_URL}${
  process.env.REACT_APP_BASE_PORT ? ':' + process.env.REACT_APP_BASE_PORT : ''
}`;

export const api = axios.create({
  baseURL: URL_ROOT,
});

export const apiLocal = axios.create({
  baseURL: URL_ROOT,
});

interface AxiosRequest {
  method: string;
  url: string;
  data?: any;
  params?: any;
  withCredentials?: boolean;
}

export const setupAxios = ({
  method,
  url,
  data,
  params,
  withCredentials,
}: AxiosRequestConfig<AxiosRequest> | any) => {
  const token = localStorage.getItem('telemedicina_access_token');
  return api({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: withCredentials ? `Bearer ${token}` : '',
    },
    data: data,
    params: params,
  });
};

export const setupLocalAxios = ({
  method,
  url,
  data,
  params,
  withCredentials,
}: AxiosRequestConfig<AxiosRequest>) => {
  const token = localStorage.getItem('telemedicina_access_token');
  return apiLocal({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: withCredentials ? `Bearer ${token}` : '',
    },
    data: data,
    params: params,
  });
};
